<template>
  <app-modal
    v-bind="$attrs"
    title="エクストラネット承認"
    ref="modal"
    class="modal-container"
    content-class="modal-medium"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <div class="font-weight-bold mb-3">
                  誤って承認した場合、情報漏洩やお客様の通信に支障を及ぼす可能性があります。
                </div>
                <connection-info-table
                  :connectionInfo="confirmData"
                  :is-extranet-approval="true"
                />
                <v-divider class="mt-2"></v-divider>
                <p class="font-weight-bold mt-3">
                  申請されたPINコードを入力してください。
                </p>
                <!-- PINコード -->
                <v-row>
                  <v-col class="mt-3">
                    <app-badge
                      item="PINコード"
                      :msg="$filter.message('info_pin_code')"
                      placement="end"
                    ></app-badge>
                    <validation-provider
                      v-model="confirmPINCode"
                      label="PINコード"
                      name="pinCode"
                      :rules="{
                        required: true,
                        length: { length: 4 },
                        is_half_width_alpha_lowercase_numeric: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- オーダー備考 -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="オーダー備考"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '200',
                        })
                      "
                      :isRequired="false"
                      placement="end"
                    ></app-badge>
                    <validation-provider
                      v-model="confirmNote"
                      label="オーダー備考"
                      name="confirmNote"
                      :rules="{
                        max: { length: 200 },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-list-item class="w-100 pa-1">
                    <template v-slot:append>
                      <v-btn type="submit" variant="flat" color="primary"
                        >承認</v-btn
                      >
                      <v-btn @click="cancel" variant="outlined" color="primary"
                        >キャンセル</v-btn
                      >
                    </template>
                  </v-list-item>
                </v-card-actions>
              </v-container>
            </div>
          </v-card-text>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { ExtranetInfo, PutExtranetInfo } from "@/apis/ExtranetApi";
import ConnectionInfoTable from "@/components/extranet/ConnectionInfoTable.vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "ExtranetConnectApproval",
  components: { ConnectionInfoTable },
  props: {
    confirmData: {
      type: Object as PropType<ExtranetInfo>,
      required: true,
    },
    extranetKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      confirmPINCode: "",
      confirmNote: null,
    };
  },
  methods: {
    async submit() {
      await this.$confirm(`エクストラネット接続を承認します。よろしいですか？

        承認した場合、申請されたネットワークと接続されます。
        誤って承認した場合、情報漏洩やお客様の通信に支障を及ぼす可能性があります。
      `);

      // APIで送信するデータの設定
      const data: PutExtranetInfo = {
        pinCode: this.confirmPINCode,
        approvalRequest: "APPROVE",
        note: this.confirmNote || null,
        extranetKeyId: this.extranetKeyId,
      };

      // APIによるエクストラネット承認処理
      await this.$api.extranetApi.putExtranet(
        this.confirmData.extranetSeq,
        data
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
